import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const masterFieldCategoryAPI = createApi({
    reducerPath:'masterFieldCategoryAPI',
    baseQuery:defaultBaseQuery,
    endpoints: (builder)=>({

        addMasterFieldCategory: builder.mutation({
            query: (data) => ({
                url: `/MasterFieldCategory/AddMasterFieldCategory`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateMasterFieldCategory: builder.mutation({
            query: (data) => ({
                url: `/MasterFieldCategory/UpdateMasterFieldCategory`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getMasterFieldCategoryList: builder.mutation({
            query: (data) => ({
                url: `/MasterFieldCategory/GetMasterFieldCategory`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteMasterFieldCategory: builder.mutation({
            query: (Id) => ({
                url: `/MasterFieldCategory/DeleteMasterFieldCategory?Id=${Id}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateMasterFieldCategorieToggle:builder.mutation({
            query:(data)=>({
                url:`MasterFieldCategory/UpdateMasterFieldCategorieToggle`,
                method:"POST",
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    })
})

export const {
useAddMasterFieldCategoryMutation,
useUpdateMasterFieldCategoryMutation,
useGetMasterFieldCategoryListMutation,
useDeleteMasterFieldCategoryMutation,
useUpdateMasterFieldCategorieToggleMutation
} = masterFieldCategoryAPI;

export default masterFieldCategoryAPI;

